import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LocationSection from './components/LocationSection';
import ServicesSection from '../../home/components/ServicesSection';
import BenefitsSection from '../../home/components/BenefitsSection';
import TintShadesSection from '../../home/components/TintShadesSection';
import TestimonialsSection from '../../home/components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from '../../home/components/CTASection';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../../utils/seo';
import { useEffect } from 'react';

export default function EllicottCityPage() {
  // Apply localized SEO metadata with geo-tags
  useSEO({
    title: 'Ellicott City Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
    description:
      'Professional window tinting services in Ellicott City, Maryland. Expert ceramic tint installation, mobile service, commercial tinting, vehicle decals, and headlight tinting. Serving Ellicott City, Columbia, Catonsville. Lifetime warranty. Call (443) 800-0348.',
    keywords:
      'window tinting Ellicott City, ceramic tint Ellicott City MD, mobile tinting Ellicott City, commercial tinting Ellicott City, vehicle decals Ellicott City',
    canonical: '/locations/ellicott-city',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          ...generateLocalBusinessSchema(),
          '@type': 'AutoRepair',
          name: 'U.B.K Window Tint - Ellicott City',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '',
            addressLocality: 'Ellicott City',
            addressRegion: 'MD',
            postalCode: '21043',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '39.2673',
            longitude: '-76.7983',
          },
          areaServed: {
            '@type': 'City',
            name: 'Ellicott City',
            '@id': 'https://en.wikipedia.org/wiki/Ellicott_City,_Maryland',
          },
        },
        generateWebPageSchema(
          'Ellicott City Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
          'Professional window tinting services in Ellicott City, Maryland with lifetime warranty and same-day service.',
          '/locations/ellicott-city'
        ),
      ],
    },
  });

  useEffect(() => {
    // Add geo meta tags for local SEO
    const geoTags = [
      { name: 'geo.region', content: 'US-MD' },
      { name: 'geo.placename', content: 'Ellicott City' },
      { name: 'geo.position', content: '39.2673;-76.7983' },
      { name: 'ICBM', content: '39.2673, -76.7983' },
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">
          Ellicott City Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint
        </h1>
      </header>
      <main>
        <HeroSection />
        <LocationSection />
        <ServicesSection />
        <BenefitsSection />
        <TintShadesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
